<ng-container *ngrxLet="columnNote$; let columnNote">
  <button
      [ngClass]="{
      dynamicColumnNote: true,
      opened: stickyNoteOpened
    }"
      [matMenuTriggerFor]="columnNoteMenu"
      [class]="columnNote?.noteColor"
      (onMenuOpen)="onMenuOpen()"
      mat-icon-button (click)="setMenuVisibility(true)">

    @if (!getLengthLimits(columnNote).currentPersisted) {
      <mat-icon
          svgIcon="sticky_note_empty_add"></mat-icon>
    }
    @if (getLengthLimits(columnNote).currentPersisted) {
      <mat-icon
          svgIcon="sticky_note_with_content"></mat-icon>
    }
  </button>

  <mat-menu class="dynamicColumnNoteMenu" #columnNoteMenu="matMenu"
            (close)="setMenuVisibility(false)">
    <div class="columnHeader">
      <p class="columnNoteHeaderText">{{ getPrettyColumnName(columnID) }}</p>

      <mat-icon [ngClass]="{disabled: !columnNote?.id}"
                (click)="deleteColumnNote($event, columnNote)"
                class="material-icons deleteIcon"
                svgIcon="delete_outline">
      </mat-icon>
    </div>

    <div class="noteTextareaWrapper" (click)="$event.stopPropagation()">
      <textarea [id]="noteTextAreaID"
                #noteTextArea
                class="noteTextarea"
                matInput
                appGxInput
                placeholder="Comment"
                cdkTextareaAutosize
                cdkAutosizeMaxRows="10"
                [value]="getNoteInputValue(columnNote?.noteText, noteTextArea.value, noteTextAreaFocused)"
                (input)="onTextChange($event, columnNote)"
                (focus)="$event.stopPropagation()"
                (focusin)="noteTextAreaFocused = true"
                (focusout)="noteTextAreaFocused = false"
                [maxLength]="getLengthLimits(columnNote).allowed"
                (dblclick)="handleTextAreaDoubleClick($event)"></textarea>
      <div class="noteIconsContainer">
        @if (columnNote?.loading) {
          <mat-progress-spinner
              diameter="21"
              class="saving"
              mode="indeterminate"
              strokeWidth="3"></mat-progress-spinner>
        }

        <div class="copyIcon"
             [ngStyle]="{
            opacity: !columnNote?.loading
                && textareaValue?.length ? 1 : 0,
            visibility: !columnNote?.loading
                && textareaValue?.length ? 'visible' : 'hidden'
           }"
             (click)="copyNoteContent($event)">
          <mat-icon class="material-icons-outlined" svgIcon="content_copy"></mat-icon>
        </div>
      </div>
    </div>

    <div class="flex w-full justify-end">
      <span class="charCounter">{{getLengthLimits(columnNote).current}} / {{getLengthLimits(
          columnNote).allowed}}</span>
    </div>

    <div class="colorsWrapper">
      <span class="text">{{'COLOR.SINGULAR' | translate}}</span>

      <mat-button-toggle-group class="noteColorToggleGroup"
                               (change)="onColorChange($event, columnNote)"
                               [value]="columnNote?.noteColor">

        @for (color of noteColors; track color) {
          <mat-button-toggle
              class="statusToggleButton"
              (click)="$event.stopPropagation()"
              disableRipple="true"
              [ngClass]="color"
              [value]="color">
            @if (color === columnNote?.noteColor) {
              <mat-icon
                  svgIcon="done"></mat-icon>
            }
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

  </mat-menu>
</ng-container>